module.exports = __webpack_public_path__ + "img/136.8c7c91d8.jpg";